/* ============================================================================
   RECETTAGE MOBILE 25/09 — « les vidéos de l'accueil ne se lancent pas,
   on voit un bouton play »
   ----------------------------------------------------------------------------
   Le balisage est bon (autoplay muted loop playsinline). La cause est l'iPhone :
   en MODE ÉCONOMIE D'ÉNERGIE (batterie jaune sur les captures de Robin), iOS
   refuse toute lecture automatique et affiche son gros bouton play natif.
   Aucun site ne peut passer outre — mais iOS autorise la lecture dès que le
   visiteur a touché la page.
   Ce script relance donc, au premier toucher (n'importe où), toutes les vidéos
   censées tourner seules, puis celles qui entrent à l'écran ensuite.
   Le bouton natif est masqué en CSS sur ces vidéos : en attendant le toucher,
   le visiteur voit l'image d'affiche, propre.
   Sans effet sur un appareil normal : les vidéos y tournent déjà.
   ============================================================================ */
(function () {
  'use strict';
  var armed = false;

  function wanted(v) {
    // vidéos en lecture auto, et la vidéo centrale du carrousel UGC
    // (son script pose v._want = 1 quand il veut la lire)
    return v.hasAttribute('autoplay') || v._want === 1;
  }
  function wake(v) {
    if (!v.paused || !wanted(v)) return;
    var r = v.getBoundingClientRect();
    if (r.bottom < 0 || r.top > window.innerHeight) return;
    v.muted = v.muted || v.hasAttribute('muted');
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function wakeAll() { document.querySelectorAll('video').forEach(wake); }

  function onGesture() {
    armed = true;
    wakeAll();
  }
  ['touchend', 'click', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, onGesture, { passive: true, capture: true });
  });

  // après un premier toucher, relancer celles qui arrivent à l'écran
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      if (!armed) return;
      entries.forEach(function (e) { if (e.isIntersecting) wake(e.target); });
    }, { threshold: 0.25 });
    var watch = function () { document.querySelectorAll('video[autoplay]').forEach(function (v) { io.observe(v); }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  }
})();
